import { render, staticRenderFns } from "./SubscriptionsList.vue?vue&type=template&id=f93d023c&"
import script from "./SubscriptionsList.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionsList.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports